import React from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom';
import { YellowButton } from '../../Buttons';

interface Props {
  onCancelClick?: () => void;
  bookOBVisitURL?: string;
}

const ActionButtons = ({ onCancelClick, bookOBVisitURL }: Props) => {
  return (
    <ActionsContainer>
      {bookOBVisitURL ? (
        <>
          <BookButton as={Link} to={bookOBVisitURL}>
            Book
          </BookButton>

          <DisclaimerButton onClick={onCancelClick}>I already made my appointment</DisclaimerButton>
        </>
      ) : (
        <>
          <OkButton onClick={onCancelClick}>OK</OkButton>
        </>
      )}
    </ActionsContainer>
  );
};

export default ActionButtons;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-top: 24px;
  padding: 0px 12px;
  flex-grow: 1;
`;

const BookButton = styled(YellowButton)`
  align-self: center;
`;

const DisclaimerButton = styled.button`
  align-self: center;
  text-decoration: underline;
  padding-top: 15px;
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;

  ${({ theme }) => theme.fonts.FoundersGrotesk};
`;

const OkButton = styled(YellowButton)`
  align-self: center;
`;
